<template>
  <div class="client-manager">
    <div class="raise-top">
      <div style="display:flex;">
        <a-button type="primary" @click="toCreattask">创建养号任务</a-button>
        <div style="margin-left:5px;margin-top:5px;font-size:10px">养号任务每天执行时间为9:00-15:00；当天中午12:00前创建的任务，当天执行；12:00之后创建的任务，第2天上午9:00开始执行</div>
      </div>
      <div style="display: flex">
        <!--群聊文件 -->
        <div>
          <a-upload
            style="display: inline-block; margin-right: 5px"
            name="file"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :showUploadList="false"
            :customRequest="uploadCommonMiniParams1"
          >
            <a-button> <a-icon type="upload" /> 上传群聊文件 </a-button>
          </a-upload>
          <a
            href="https://ddywbdthumb.oss-cn-beijing.aliyuncs.com/养号_群聊内容上传模版.xlsx"
            download="券码上传模版.xlsx"
            style="color: blue;font-size:10px"
            >下载模版</a
          >
          <div v-if="this.flag1">
            <a-icon type="check-circle" theme="twoTone" style="color: green" />
            <strong>上传成功！</strong>
          </div>
        </div>
        <!-- 私聊文件 -->
        <div style="margin: 0 20px">
          <a-upload
            style="display: inline-block; margin-right: 5px"
            name="file"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :showUploadList="false"
            :customRequest="uploadCommonMiniParams2"
          >
            <a-button> <a-icon type="upload" /> 上传私聊文件 </a-button>
          </a-upload>
          <a
            href="https://ddywbdthumb.oss-cn-beijing.aliyuncs.com/养号_私聊内容上传模版.xlsx"
            download="券码上传模版.xlsx"
            style="color: blue;font-size:10px"
            >下载模版</a
          >
          <div v-if="this.flag3">
            <a-icon type="check-circle" theme="twoTone" style="color: green" />
            <strong>上传成功！</strong>
          </div>
        </div>
        <!-- 朋友圈文件 -->
        <div>
          <a-upload
            style="display: inline-block; margin-right: 5px"
            name="file"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :showUploadList="false"
            :customRequest="uploadCommonMiniParams3"
          >
            <a-button> <a-icon type="upload" /> 上传朋友圈文件 </a-button>
          </a-upload>
          <a
            href="https://ddywbdthumb.oss-cn-beijing.aliyuncs.com/养号_朋友圈内容上传模版.xlsx"
            download="券码上传模版.xlsx"
            style="color: blue;font-size:10px"
            >下载模版</a
          >
          <div v-if="this.flag2">
            <a-icon type="check-circle" theme="twoTone" style="color: green" />
            <strong>上传成功！</strong>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px">
      <a-input-search
        v-model="keyword"
        placeholder="搜索任务名称"
        style="width: 200px"
        :maxLength="30"
        @search="onSearch"
      />
    </div>
    <a-table
      :columns="columns"
      :dataSource="data"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
      class="client-table"
      style="font-size: 12px !important; margin-top: 10px"
    >
      <div class="avatar-36-con" slot="task_name" slot-scope="text">
        {{ text }}
      </div>
      <div slot="bot_type" slot-scope="tex, record">
        {{ record.bot_type === 1 ? "新号任务" : "老号任务" }}
      </div>
      <div slot="bot_total" slot-scope="text">
        {{ text }}
      </div>
      <div slot="bot_error" slot-scope="text">
        ---
      </div>
      <div slot="create_time" slot-scope="text">
        {{ text }}
      </div>
      <div slot="actions" slot-scope="text, record">
        <template>
          <a-button type="link" @click="exportData(record)">导出数据</a-button>
          <a-popover v-model="record.againSure" title="确定要删除这条任务吗？" trigger="click">
            <template slot="content" style="mergin-left:10px">
               <a type="link" @click="record.againSure = false">取消</a>
               <a-button type="link" @click="sure(record)">确定</a-button>
            </template>
            <a-button type="link">
              删除
            </a-button>
          </a-popover>
          <!-- <a-button type="link" @click="delTask(record)">删除</a-button> -->
        </template>
      </div>
    </a-table>
    <!-- 导出数据弹框 -->
    <a-modal
      v-model="visible"
      title="导出数据"
      @ok="handleOk"
      @cancel="handlerCancel"
      cancelText="取消"
      okText="导出" 
    >
      <div>
        <div class="tip">（仅支持导出近七天数据）</div>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          layout="inline"
        >
          <a-form-model-item label="导出时间段" prop="exportdate">
            <!-- <a-range-picker
              v-model="form.exportdate"
              :show-time="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              :disabledDate="disabledDate"
              @change="onChange"
            /> -->
            <a-range-picker
             v-model="form.exportdate"
             :placeholder="['开始时间', '结束时间']"
             :disabledDate="disabledDate"
             @change="onChange" 
             />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
const axios = require("axios");
export default {
  name: "RaiseAccount",
  data() {
    return {
      //上传素材
      uploadExcalUrl: global.DOMAIN + "Raisebot/add_material",
      //获取养号任务列表
      getRaiselistUrl: global.DOMAIN + "Raisebot/get_bot",
      //导出数据
      exportDataUrl: global.DOMAIN + "Raisebot/export_raise_task",
      //删除
      delDataUrl: global.DOMAIN + "Raisebot/del_bot",
      keyword: "",
      material_type: undefined,
      flag1: false,
      flag2: false,
      flag3: false,
      pagination: {
        showTotal: (total) => `共 ${total} 个任务`,
        pageSize: 10,
        current: 1,
      },
      data: [],
      loading: false,
      columns: [
        {
          title: "任务名称",
          dataIndex: "task_name",
          scopedSlots: { customRender: "task_name" },
        },
        {
          title: "任务类型",
          dataIndex: "bot_type",
          scopedSlots: { customRender: "bot_type" },
        },
        {
          title: "小助手总量",
          dataIndex: "bot_total",
          scopedSlots: { customRender: "bot_total" },
        },
        {
          title: "异常小助手数量",
          dataIndex: "bot_error",
          scopedSlots: { customRender: "bot_error" },
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
        },
        {
          title: "操作",
          dataIndex: "actions",
          scopedSlots: { customRender: "actions" },
          align: "center",
        },
      ],
      visible: false,
      form: {
        exportdate: [],
      },
      rules: {
        exportdate: [
          {
            type: "array",
            required: true,
            message: "导出日期不可为空",
            trigger: "blur",
          },
        ],
      },
      task_id: undefined,
    };
  },
  computed: {
    params: function () {
      return {
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
        keyword: this.keyword,
      };
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    // 跳转创建养号task
    toCreattask() {
      this.$router.push("/CreatRaisetask");
    },
    //素材上传类型区分
    uploadCommonMiniParams1(info) {
      this.material_type = 1;
      this.uploadExcalFn(info);
    },
    uploadCommonMiniParams2(info) {
      this.material_type = 3;
      this.uploadExcalFn(info);
    },
    uploadCommonMiniParams3(info) {
      this.material_type = 2;
      this.uploadExcalFn(info);
    },
    //调用上传接口
    uploadExcalFn(info) {
      let formData = new FormData();
      formData.append("file", info.file);
      formData.append("material_type", this.material_type);
      formData.append("token", sessionStorage.token);
      this.axios.post(this.uploadExcalUrl, formData).then((res) => {
        if (res.data.err_code === 0) {
          if (this.material_type == 1) {
            this.flag1 = true;
          } else if (this.material_type == 3) {
            this.flag3 = true;
          } else {
            this.flag2 = true;
          }
        } else {
          if (this.material_type == 1) {
            this.flag1 = false;
            this.$message.error('请下载模板并按提示进行填写，确保包含’群性质‘和’内容‘！');
          } else if (this.material_type == 2) {
            this.flag2 = false;
            this.$message.error('请下载模板并按提示进行填写，确保包含’文本内容‘和’图片‘！');
          } else {
            this.flag3 = false;
            this.$message.error('请下载模板并按提示进行填写，确保包含’私聊内容‘！');
          }
        }
      });
    },
    //搜索
    onSearch() {
      this.pagination.current = 1;
      this.fetch();
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch();
    },
    //获取task列表
    fetch() {
      this.loading = true;
      this.axios.post(this.getRaiselistUrl, {
          token: sessionStorage.token,
          ...this.params,
        }).then((res) => {
          if (res.data.err_code === 0) {
            const pagination = { ...this.pagination };
            pagination.total = res.data.content.total;
            this.data = res.data.content.bot_list;
            this.data.forEach((item)=>{
                item.create_time = this.transform(item.create_time, "yyyy-MM-dd hh:mm:ss")
            })
            this.loading = false;
            this.pagination = pagination;
          }
        });
    },
    transform(value, fmt, ...args) {
      if (typeof value === "number") {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11)
          value *= 1000;

        let date = new Date(value);
        var o = {
          "M+": date.getMonth() + 1, // 月份
          "d+": date.getDate(), // 日
          "h+": date.getHours(), // 小时
          "m+": date.getMinutes(), // 分
          "s+": date.getSeconds(), // 秒
          "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay(),
        };
        var weekMap = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt) && k !== "W") {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
          if (new RegExp("(" + k + ")").test(fmt) && k === "W") {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]]);
          }
        }
        return fmt;
      } else return "";
    },
    //导出数据
    exportData(record) {
      this.raise_bot_id = record.raise_bot_id;
      this.visible = true;
    },
    //只可选择时间
    disabledDate(current) {
      return (
        current > moment().subtract("days") ||
        current < moment().subtract(7, "day")
      );
    },
    onChange(date, dateString) {
      this.form.exportdate = dateString;
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          //整理参数
          let costTime = 8*360*1000
          let start_time = Date.parse(this.form.exportdate[0]) / 1000;
          let end_time = Date.parse(this.form.exportdate[1]) / 1000;
          this.axios.post(this.exportDataUrl, {
              token: sessionStorage.token,
              raise_bot_id: this.raise_bot_id,
              start_time: start_time,
              end_time: end_time,
            }).then((res) => {
              if (res.data.err_code === 0) {
                //窗口下载
                window.open(res.data.content.url);
                this.visible = false;
                this.form.exportdate = [];
              } else {
                this.$message.error(res.data.discription);
              }
            });
        } else {
          return false;
        }
      });
    },
    handlerCancel() {
      this.visible = false;
      this.form.exportdate = [];
      this.$refs.ruleForm.resetFields();
    },
    sure(record) {
      this.raise_bot_id = record.raise_bot_id;
      record.againSure = false;
      this.delTask()
    },
    //删除
    delTask() {
      this.axios
        .post(this.delDataUrl, {
          token: sessionStorage.token,
          raise_bot_id: this.raise_bot_id,
        })
        .then((res) => {
          if (res.data.err_code === 0) {
            this.$message.success("删除成功");
            this.fetch();
          } else {
            this.$message.error(res.data.discription);
          }
        });
    },
  },
};
</script>

<style scoped>
.raise-top {
  display: flex;
  justify-content: space-between;
}
.tip {
  position: absolute;
  top: 0px;
  left: 85px;
  font-size: 10px;
  top: 19px;
}
</style>
